/**
 * External dependencies
 */

import { omit } from 'lodash';
import { combineReducers } from 'redux';

/**
 * Internal dependencies
 */
import { NOTICE_CREATE, NOTICE_REMOVE } from 'state/action-types';
import { createReducer } from 'state/utils';

export const items = createReducer(
    {},
    {
        [NOTICE_CREATE]: (state, action) => {
            const { notice } = action;
            return {
                ...state,
                [notice.noticeId]: notice,
            };
        },
        [NOTICE_REMOVE]: (state, action) => {
            const { noticeId } = action;
            if (!state.hasOwnProperty(noticeId)) {
                return state;
            }

            return omit(state, noticeId);
        },
    },
);

export const lastTimeShown = createReducer(
    {},
    {
        [NOTICE_CREATE]: (state, action) => {
            const { notice } = action;
            return {
                ...state,
                [notice.noticeId]: Date.now(),
            };
        },
    },
);

export default combineReducers({
    items,
    lastTimeShown,
});
